import axios from 'axios'

export const consumption = async (): Promise<Record<string, Record<string, number>>[]> => {
  const axiosApi = axios.create()
  const { data: consumption } = await axiosApi.get(`https://hub.glooh.io/1fc58a08-94f5-4edc-8e27-6959c2b2d0f1`)
  return consumption as Record<string, Record<string, number>>[]
}
